import { ESTADO_REQUISITO } from "./commons";
import { Rol } from "./roles";

export const ENABLE_CODE_SECTION = {
    LINK_DETAIL_APPOINTMENT: "001",
    SEARCH_APPOINTMENT: "002",
    CANCEL_APPOINTMENT: "003",
    DETAIL_APPOINMENT: "002",
    SCHEDULE_APPOINMENT: "003",
    NEW_REQUEST_REQUIREMENT: "007",
    LINK_DETAIL_REQUIREMENT: "003",
    SEARCH_REQUIREMENT: "002",
    CANCEL_REQUIREMENT: "008",
    DETAIL_ADD_REQUIREMENT: "002",
    DETAIL_SAVE_EVALUATE: "014",
    DETAIL_ADD_OBSERVATION_EVALUATE: "012",
    DETAIL_ANNULAR_EVALUATE: "015",
    DETAIL_ADD_DOCUMENT_POST_EVALUATE: "002",
    DETAIL_ADD_NEW_REQUIREMENT_EVALUATE: "002",
    HOME_ANNULAR_EVALUATE: "006",
}

export const ACTIONS_OPTIONS = {
  view_requirement: "Ver requisito",
  annular: "Anular",
  edit: "Editar",
  realize: "Realizar",
  uploadImage: "Subir imagen",
  endorsement: "Carta de endoso",
  addRequirement: "Agregar requisito"
};

export const VIEW_CANCEL_EDIT_OPTIONS: string[] = [ACTIONS_OPTIONS.view_requirement, ACTIONS_OPTIONS.annular, ACTIONS_OPTIONS.edit];
export const BASE_OPTIONS: string[] = [ACTIONS_OPTIONS.view_requirement, ACTIONS_OPTIONS.annular, ACTIONS_OPTIONS.realize, ACTIONS_OPTIONS.edit];
export const VIEW_EDIT_OPTIONS: string[] = [ACTIONS_OPTIONS.view_requirement, ACTIONS_OPTIONS.edit];
export const PACIFICO_OPTIONS_BASE: string[] = [ACTIONS_OPTIONS.view_requirement, ACTIONS_OPTIONS.uploadImage, ACTIONS_OPTIONS.realize, ACTIONS_OPTIONS.edit];
export const ONLY_VIEW_OPTION: string[] = [ACTIONS_OPTIONS.view_requirement];

export const FULL_MENU_STATES: number[] = [
  ESTADO_REQUISITO.NO_PROGRAMADO,
  ESTADO_REQUISITO.PROGRAMADO,
  ESTADO_REQUISITO.NO_REALIZADO,
  ESTADO_REQUISITO.CONFIRMADO,
];

export const DESCRIPTION_PROFILE_ROLE = {
  [Rol.CITAS_MEDICAS]: "Programación y gestión de citas médicas, horarios de especialistas.",
  [Rol.EJECUTIVO_DESGRAVAMEN]: "Administración de documentos y requisitos para servicios médicos.",
  [Rol.EVALUATOR]: "Revisión y evaluación de solicitudes de servicios médicos."
}